export default ({ request }) => ({
  sampleSetInfoListApi(data = {}) {
    return request({
      url: '/master/sample/set/info/list',
      method: 'post',
      data,
    })
  },
  sampleSetInfoDetailApi(data = {}) {
    return request({
      url: '/master/sample/set/info/detail',
      method: 'post',
      data,
    })
  },
  sampleSetInfoSaveApi(data = {}) {
    return request({
      url: '/master/sample/set/info/save',
      method: 'post',
      data,
    })
  },
  sampleSetInfoDelApi(data = {}) {
    return request({
      url: '/master/sample/set/info/del',
      method: 'post',
      data,
    })
  },
  sampleSetInfoCopyApi(data = {}) {
    return request({
      url: '/master/sample/set/info/copy',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sampleSetInfoReviewApi(data = {}) {
    return request({
      url: '/master/sample/set/info/review',
      method: 'post',
      data,
    })
  },
  sampleSetInfoRejectApi(data = {}) {
    return request({
      url: '/master/sample/set/info/reject',
      method: 'post',
      data,
    })
  },
  sampleSetInfoChangeApi(data = {}) {
    return request({
      url: '/master/sample/set/info/change',
      method: 'post',
      data,
    })
  },
})
